import { useState } from 'react';
import { Box } from 'reflexbox';
import { Popover } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing.unit,
  },
});

const PopoverCustom = ({ children, classes, content }) => {
  const [anchorEl, setAnchorEl] = useState(false);

  const handleOpen = (event) => setAnchorEl(event.currentTarget );
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  return (
    <div>
      <Box
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        {children}
      </Box>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
        disableRestoreFocus
      >
        {content}
      </Popover>
    </div>
  );
};

export default withStyles(styles)(PopoverCustom);
